// RoomScene.jsx
// The interactive room map — matches room.php's `.map-container` holding
// `.escape-map-desktop` (escape1.php) and `.escape-map-mob-portrait`
// (escape_mob.php). Both variants render together and CSS toggles which is
// visible per breakpoint, exactly like the PHP markup does.
import React from 'react';
import RoomObject from './RoomObject';
import { ROOM_OBJECTS } from '../../../games/escape-to-inner-peace/data/roomObjects';
import roomDesktopBg from '../../../assets/escape-to-inner-peace/backgrounds/escape1.png';
import roomMobileBg from '../../../assets/escape-to-inner-peace/room/room-mobile-bg.png';
import './RoomScene.css';

function RoomScene({ onObjectClick, isUnlocked, isCompleted }) {
  return (
    <div className="escape-map-container">
      <div className="escape-map-desktop">
        <div className="escape-room-scene escape-room-scene-desktop">
          <img src={roomDesktopBg} alt="Escape room" className="escape-room-scene-bg" draggable={false} />
          {ROOM_OBJECTS.map((obj) => (
            <RoomObject
              key={obj.id}
              id={obj.id}
              label={obj.label}
              image={obj.desktop.image}
              left={obj.desktop.left}
              top={obj.desktop.top}
              width={obj.desktop.width}
              height={obj.desktop.height}
              onClick={onObjectClick}
              testId={`escape-room-object-${obj.id}`}
              locked={!isUnlocked(obj.id)}
              completed={isCompleted(obj.id)}
            />
          ))}
        </div>
      </div>

      <div className="escape-map-mob-portrait">
        <div className="escape-room-scene escape-room-scene-mobile">
          <img src={roomMobileBg} alt="Escape room" className="escape-room-scene-bg" draggable={false} />
          {ROOM_OBJECTS.map((obj) => (
            <RoomObject
              key={obj.id}
              id={obj.id}
              label={obj.label}
              image={obj.mobile.image}
              left={obj.mobile.left}
              top={obj.mobile.top}
              width={obj.mobile.width}
              height={obj.mobile.height}
              onClick={onObjectClick}
              testId={`escape-room-object-mobile-${obj.id}`}
              locked={!isUnlocked(obj.id)}
              completed={isCompleted(obj.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default RoomScene;
